export const ISBN = {
  KEY: 'C0001',
  NAME: 'ISBN'
}

export const MARC_TYPE = {
  KEY: 'C0002',
  NAME: 'MARC区分'
}

export const CARD_TYPE = {
  KEY: 'C0003',
  NAME: 'カード区分'
}

export const BY_GENRE = {
  KEY: 'C0004',
  NAME: 'ジャンル別コード'
}

export const GENERAL_TYPE = {
  KEY: 'C0006',
  NAME: '一般資料種別'
}

export const PUBLICATION_FREQUENCY = {
  KEY: 'C0007',
  NAME: '図書：逐次刊行物種別刊行頻度'
}

export const LIBRARY_BRANCH = {
  KEY: 'C0008',
  NAME: '館コード'
}

export const CONTINUATION_STATUS_FLAG = {
  KEY: 'C0009',
  NAME: '継続状況フラグ'
}

export const SEARCH_TYPE = {
  KEY: 'C0012',
  NAME: '検索区分'
}

export const DISCRETION_COLLECTION_INSTRUCTION_FLAG = {
  KEY: 'C0013',
  NAME: '見計い資料指示フラグ'
}

export const LANGUAGE = {
  KEY: 'C0014',
  NAME: '言語コード'
}

export const WORKING_TYPE = {
  KEY: 'C0015',
  NAME: '在勤/在学区分'
}

export const COLLECTION_MEMO = {
  KEY: 'C0016',
  NAME: '資料メモ'
}

export const COLLECTION_TYPE = {
  KEY: 'C0017',
  NAME: '資料区分'
}

export const MATERIAL_FORMAT = {
  KEY: 'C0018',
  NAME: '資料形態'
}

export const COLLECTION_STATUS = {
  KEY: 'C0019',
  NAME: '資料状態'
}

export const HANDLING_TYPE = {
  KEY: 'C0020',
  NAME: '取扱区分'
}

export const ACCEPT_TYPE = {
  KEY: 'C0021',
  NAME: '受入区分'
}

export const PUBLICATION_IDENTIFIER = {
  KEY: 'C0024',
  NAME: '出版識別子'
}

export const PROCESSING_PLACE = {
  KEY: 'C0025',
  NAME: '処理場所'
}

export const BIBLIOGRAPHY_UNIT = {
  KEY: 'C0027',
  NAME: '書誌単位'
}

export const REASON_FOR_REMOVAL = {
  KEY: 'C0028',
  NAME: '除籍理由'
}

export const GENDER = {
  KEY: 'C0032',
  NAME: '性別コード'
}

export const SELECTION_TYPE = {
  KEY: 'C0035',
  NAME: '選定種別'
}

export const SELECTION_REASON = {
  KEY: 'C0036',
  NAME: '選定理由'
}

export const INTER_LIBRARY_LOAN = {
  KEY: 'C0037',
  NAME: '相互貸借館'
}

export const CLASSIFICATION = {
  KEY: 'C0038',
  NAME: '貸出分類'
}

export const LEND_TYPE = {
  KEY: 'C0039',
  NAME: '貸出区分'
}

export const LEND_STOP_REASON = {
  KEY: 'C0040',
  NAME: '貸出停止理由コード'
}

export const GROUP_TYPE = {
  KEY: 'C0041',
  NAME: '団体区分'
}

export const AUTHORITY_ID_TYPE = {
  KEY: 'C0043',
  NAME: '典拠ID区分'
}

export const PHONE_TYPE = {
  KEY: 'C0046',
  NAME: '電話区分'
}

export const SPECIFIC_TYPE = {
  KEY: 'C0047',
  NAME: '特定資料種別'
}

export const REMINDER_TYPE_SETTING = {
  KEY: 'C0048',
  NAME: '督促種別設定'
}

export const REMIND_EXCLUDE = {
  KEY: 'C0049',
  NAME: '督促抑止'
}

export const SHELF_TYPE = {
  KEY: 'C0050',
  NAME: '配架区分'
}

export const ORDER_CANCEL_REASON = {
  KEY: 'C0051',
  NAME: '発注取消理由'
}

export const ORDER_STATUS = {
  KEY: 'C0052',
  NAME: '発注状態'
}

export const EXPENSE = {
  KEY: 'C0053',
  NAME: '費目コード'
}

export const EQUIPMENT_CONSUMABLE_TYPE = {
  KEY: 'C0054',
  NAME: '備品消耗品区分'
}

export const APPENDIX = {
  KEY: 'C0055',
  NAME: '付録コード'
}

export const DEPARTMENT = {
  KEY: 'C0056',
  NAME: '部署'
}

export const SAVE = {
  KEY: 'C0057',
  NAME: '保存コード'
}

export const ROLE_TYPE = {
  KEY: 'C0058',
  NAME: '役割区分'
}

export const RESERVE_NOTE = {
  KEY: 'C0059',
  NAME: '予約メモ'
}

export const RESERVE_CONTACT_METHOD_SETTING = {
  KEY: 'C0063',
  NAME: '予約連絡方法設定'
}

export const USER_TYPE = {
  KEY: 'C0065',
  NAME: '利用者区分'
}

export const USER_STATUS = {
  KEY: 'C0066',
  NAME: '利用者状態'
}

export const USER_CONTACT_MEMO = {
  KEY: 'C0067',
  NAME: '利用者連絡メモ'
}

export const COPY_TYPE = {
  KEY: 'C0068',
  NAME: '利用統計用コピー区分'
}

export const REFERENCE_TYPE = {
  KEY: 'C0069',
  NAME: '利用統計用レファレンス区分'
}

export const EVENT_TYPE = {
  KEY: 'C0070',
  NAME: '利用統計用催し物区分'
}

export const STATISTICS_USER_TYPE = {
  KEY: 'C0071',
  NAME: '利用統計用利用者区分'
}

export const JAPANESE_AND_WESTERN_TYPE = {
  KEY: 'C0073',
  NAME: '和洋区分'
}

export const JAPANESE_CALENDAR_TYPE = {
  KEY: 'C0074',
  NAME: '和暦区分'
}

export const TRC_MARK_INFO_OF_TARGET_USERS = {
  KEY: 'C0079',
  NAME: 'TRCマーク情報（利用対象）'
}

export const RESERVE_CANCEL_REASON = {
  KEY: 'C0082',
  NAME: '予約キャンセル理由コード'
}

export const MAIL_TYPE = {
  KEY: 'C0084',
  NAME: 'メール区分'
}

export const CONTACTS_INFO_TYPE = {
  KEY: 'C0085',
  NAME: '連絡先区分'
}

export const OPAC_REGISTRATION_AVAILABILITY = {
  KEY: 'C0089',
  NAME: 'OPAC登録可否'
}

export const LEND_OUT_COLLECTION_LOST_EXPULSION_TYPE = {
  KEY: 'C0090',
  NAME: '貸出中資料の紛失・除籍区分'
}

export const FORWARDING_REQUEST_LEVEL = {
  KEY: 'C0097',
  NAME: '依頼レベル'
}

export const BUSINESS_TYPE = {
  KEY: 'C0099',
  NAME: '業務種別'
}

export const TOOLI_ORDER_TYPE = {
  KEY: 'C0100',
  NAME: 'Tooli発注用の発注種別'
}

export const TRC_CUSTOMER_CODE_NAME_SETTING = {
  KEY: 'C0102',
  NAME: 'TRC顧客コード名称設定'
}

export const REFERENCE_ANSWER_STAGE = {
  KEY: 'C0107',
  NAME: 'レファレンス回答段階'
}

export const REFERENCE_PUBLIC_LEVEL = {
  KEY: 'C0108',
  NAME: 'レファレンス公開レベル'
}

export const DB_REGISTRATION_AVAILABILITY = {
  KEY: 'C0109',
  NAME: '協同データベース登録可否'
}

export const REFERENCE_RESEARCH_TYPE = {
  KEY: 'C0111',
  NAME: 'レファレンス調査種別'
}

export const REFERENCE_CONTENT_TYPE = {
  KEY: 'C0112',
  NAME: 'レファレンス内容種別'
}

export const REFERENCE_QUESTIONER_TYPE = {
  KEY: 'C0113',
  NAME: 'レファレンス質問者種別'
}

export const ONLINE_INSPECTION_LIST = {
  KEY: 'C0120',
  NAME: 'オンライン蔵書点検リスト'
}

export const RESERVE_WORK_TYPE = {
  KEY: 'C0126',
  NAME: '予約業務区分'
}

export const SAVE_DEADLINE = {
  KEY: 'C0128',
  NAME: '保存期限'
}

export const OPAC_PUBLIC_AVAILABILITY = {
  KEY: 'C0130',
  NAME: 'ＯＰＡＣ公開可否'
}

export const BATCH_GROUP = {
  KEY: 'C0134',
  NAME: 'バッチグループ'
}

export const GENRE = {
  KEY: 'C0200',
  NAME: 'ジャンル'
}

export const TRC_MARK_INFO_OF_TARGET_USERS_AV = {
  KEY: 'C0202',
  NAME: 'TRCマーク情報（AV利用対象）'
}

export const AGE_RANGE = {
  KEY: 'C0203',
  NAME: '年齢範囲（年齢別統計用）'
}

export const USER_MAIL_CONTACT_TYPE = {
  KEY: 'C0204',
  NAME: '利用者メールアドレス連絡種別'
}

export const SCHOOL_GRADE_CODE = {
  KEY: 'C0205',
  NAME: '学校用学年コード'
}

export const SCHOOL_CLASS_CODE = {
  KEY: 'C0206',
  NAME: '学校用クラスコード'
}

export const DEFAULT_FORWARDING_REQUEST_BRANCH = {
  KEY: 'P0014',
  NAME: '依頼先館コードプリセット値設定'
}

export const PRESET_VALUE_SETTING_ON_SEARCH1 = {
  KEY: 'P0033',
  NAME: '検索時プリセット値設定1'
}

export const PRESET_VALUE_SETTING_ON_SEARCH2 = {
  KEY: 'P0034',
  NAME: '検索時プリセット値設定2'
}

export const ONE_HIT_TRANSITION_TARGET_SETTING_ON_SEARCH = {
  KEY: 'P0035',
  NAME: '検索時一件ヒット遷移先設定'
}

export const CALL_NUMBER_SETTING = {
  KEY: 'P0054',
  NAME: '処理別請求記号設定可否'
}

export const CALL_CONCATENATION_NUMBER_INSTRUCTION = {
  KEY: 'P0069',
  NAME: '請求連結記号指示'
}

export const LEND_RECEIPT_OUTPUT_DEFAULT_SETTING1 = {
  KEY: 'P0081',
  NAME: '貸出期限票出力デフォルト設定１'
}

export const LEND_RECEIPT_OUTPUT_DEFAULT_SETTING2 = {
  KEY: 'P0082',
  NAME: '貸出期限票出力デフォルト設定２'
}

export const NUMBER_MANAGEMENT = {
  KEY: 'P0107',
  NAME: '番号管理コード'
}

export const RETURN_HISTORY_SETTING = {
  KEY: 'P0118',
  NAME: '返却履歴設定'
}

export const USER_REGISTRATION_UPDATE_REQUIRED_ITEM_SETTING = {
  KEY: 'P0183',
  NAME: '利用者登録更新必須項目設定'
}

export const DETAIL_LIST_DISPLAY_SETTING_3 = {
  KEY: 'P0188',
  NAME: '詳細一覧画面 表示設定3'
}

export const RESERVE_METHOD_PRESET_SETTING = {
  KEY: 'P0189',
  NAME: '全館・特定館プリセット値設定'
}

export const USER_OPAC_PASSWORD_SETTING = {
  KEY: 'P0143',
  NAME: '利用者暗証番号設定'
}

export const APPENDIX_LEND_MANAGEMENT_USING_ENABLED_SETTING = {
  KEY: 'P0179',
  NAME: '付録貸出管理使用可否設定'
}

export const RETURNED_RESERVE_STATUS_SETTING = {
  KEY: 'P0187',
  NAME: '予約資料が返却された時の予約状態設定'
}

export const TOOLI_BIBLIOGRAPHY_REGISTER_PARAMETER2 = {
  KEY: 'P0195',
  NAME: 'ＴＯＯＬｉ発注時の書誌登録パラメータ２'
}

export const RESERVE_CONTACT_METHOD_DEFAULT_VALUE_SETTING = {
  KEY: 'P0198',
  NAME: '予約連絡方法デフォルト値設定'
}

export const MOBILE_LIBRARY_PROCESSING_PLACE = {
  KEY: 'P0203',
  NAME: '移動図書館処理場所'
}

export const RESERVE_FORWARDING_ENABLED_SETTING = {
  KEY: 'P0204',
  NAME: '回送依頼機能使用可否設定'
}

export const LEND_OUT_COLLECTION_DISPLAY_SETTING = {
  KEY: 'P0205',
  NAME: '貸出中資料表示設定'
}

export const FAMILY_MANAGEMENT_BASIC_NUMBER_SETTING = {
  KEY: 'P0214',
  NAME: '家族管理基本番号設定'
}

export const MAIL_HISTORY_SETTING = {
  KEY: 'P0215',
  NAME: 'メール履歴使用可否'
}

export const INSPECTION_MAX_NUMBER = {
  KEY: 'P0220',
  NAME: '蔵書点検リスト最大取得件数'
}

export const PROCESSING_METHOD_SETTING = {
  KEY: 'P0232',
  NAME: '処理方法設定'
}

export const LEND_RETURN_MESSAGE_OUTPUT_SETTING = {
  KEY: 'P0240',
  NAME: '貸出返却メッセージ出力方式設定'
}

export const RESERVE_SPECIFY_BRANCH_CODE_DEFAULT_SETTING = {
  KEY: 'P0260',
  NAME: '予約特定館初期値設定'
}

export const REMINDER_METHOD_SETTING = {
  KEY: 'P0287',
  NAME: '督促方式設定'
}

export const LEND_METHOD_SETTING = {
  KEY: 'P0303',
  NAME: '貸出処理方法設定'
}

export const ORDER_LIST_EDIT_DISPLAY_SETTING = {
  KEY: 'P0309',
  NAME: '発注リストの編集画面表示設定'
}

export const RETURN_HISTORY_DISPLAY_ENABLED_SETTING = {
  KEY: 'P0314',
  NAME: '返却履歴表示可否設定'
}

export const REFERENCE_SEARCH_DISPLAY_SETTING = {
  KEY: 'P0322',
  NAME: 'レファレンス検索表示設定'
}

export const USER_NEW_REGISTRATION_DEFAULT_VALUE_SETTING = {
  KEY: 'P0350',
  NAME: '利用者新規登録デフォルト値設定'
}

export const LEND_OUT_TAB_DISPLAY_ITEM_SETTING = {
  KEY: 'P0368',
  NAME: '貸出中タブの表示項目設定'
}

export const RESERVE_TYPE_SELECT_DISPLAY_ENABLED = {
  KEY: 'P2005',
  NAME: '予約種別選択画面表示可否'
}

export const USER_SEARCH_PAGE_INITIAL_FOCUS = {
  KEY: 'P2006',
  NAME: ''
}

export const CODE_MASTER = {
  KEY: 'コードマスタ',
  NAME: 'コードマスタ'
}

export const TRADER = {
  KEY: '',
  NAME: '業者'
}

export const DONOR = {
  KEY: '',
  NAME: '寄贈者'
}

/**
 * 西暦ソート用配列
 * R:令和
 * H:平成
 * S:昭和
 * T:大正
 * M:明治
 **/
export const JAPANESE_CALENDAR_SORT = ['R', 'H', 'S', 'T', 'M']

export default {
  ISBN,
  MARC_TYPE,
  CARD_TYPE,
  BY_GENRE,
  GENERAL_TYPE,
  PUBLICATION_FREQUENCY,
  LIBRARY_BRANCH,
  CONTINUATION_STATUS_FLAG,
  SEARCH_TYPE,
  DISCRETION_COLLECTION_INSTRUCTION_FLAG,
  LANGUAGE,
  WORKING_TYPE,
  COLLECTION_MEMO,
  COLLECTION_TYPE,
  MATERIAL_FORMAT,
  COLLECTION_STATUS,
  HANDLING_TYPE,
  ACCEPT_TYPE,
  PUBLICATION_IDENTIFIER,
  PROCESSING_PLACE,
  BIBLIOGRAPHY_UNIT,
  REASON_FOR_REMOVAL,
  GENDER,
  SELECTION_TYPE,
  SELECTION_REASON,
  INTER_LIBRARY_LOAN,
  CLASSIFICATION,
  LEND_TYPE,
  LEND_STOP_REASON,
  GROUP_TYPE,
  AUTHORITY_ID_TYPE,
  PHONE_TYPE,
  SPECIFIC_TYPE,
  REMINDER_TYPE_SETTING,
  REMIND_EXCLUDE,
  SHELF_TYPE,
  ORDER_CANCEL_REASON,
  ORDER_STATUS,
  EXPENSE,
  EQUIPMENT_CONSUMABLE_TYPE,
  APPENDIX,
  DEPARTMENT,
  SAVE,
  ROLE_TYPE,
  RESERVE_NOTE,
  RESERVE_CONTACT_METHOD_SETTING,
  USER_TYPE,
  USER_STATUS,
  USER_CONTACT_MEMO,
  COPY_TYPE,
  REFERENCE_TYPE,
  EVENT_TYPE,
  STATISTICS_USER_TYPE,
  JAPANESE_AND_WESTERN_TYPE,
  JAPANESE_CALENDAR_TYPE,
  TRC_MARK_INFO_OF_TARGET_USERS,
  RESERVE_CANCEL_REASON,
  MAIL_TYPE,
  CONTACTS_INFO_TYPE,
  OPAC_REGISTRATION_AVAILABILITY,
  LEND_OUT_COLLECTION_LOST_EXPULSION_TYPE,
  FORWARDING_REQUEST_LEVEL,
  BUSINESS_TYPE,
  TOOLI_ORDER_TYPE,
  TRC_CUSTOMER_CODE_NAME_SETTING,
  REFERENCE_ANSWER_STAGE,
  REFERENCE_PUBLIC_LEVEL,
  DB_REGISTRATION_AVAILABILITY,
  REFERENCE_RESEARCH_TYPE,
  REFERENCE_CONTENT_TYPE,
  REFERENCE_QUESTIONER_TYPE,
  ONLINE_INSPECTION_LIST,
  RESERVE_WORK_TYPE,
  SAVE_DEADLINE,
  BATCH_GROUP,
  OPAC_PUBLIC_AVAILABILITY,
  GENRE,
  TRC_MARK_INFO_OF_TARGET_USERS_AV,
  AGE_RANGE,
  USER_MAIL_CONTACT_TYPE,
  SCHOOL_GRADE_CODE,
  SCHOOL_CLASS_CODE,
  DEFAULT_FORWARDING_REQUEST_BRANCH,
  PRESET_VALUE_SETTING_ON_SEARCH1,
  PRESET_VALUE_SETTING_ON_SEARCH2,
  ONE_HIT_TRANSITION_TARGET_SETTING_ON_SEARCH,
  CALL_NUMBER_SETTING,
  CALL_CONCATENATION_NUMBER_INSTRUCTION,
  LEND_RECEIPT_OUTPUT_DEFAULT_SETTING1,
  LEND_RECEIPT_OUTPUT_DEFAULT_SETTING2,
  NUMBER_MANAGEMENT,
  RETURN_HISTORY_SETTING,
  USER_REGISTRATION_UPDATE_REQUIRED_ITEM_SETTING,
  DETAIL_LIST_DISPLAY_SETTING_3,
  RESERVE_METHOD_PRESET_SETTING,
  USER_OPAC_PASSWORD_SETTING,
  APPENDIX_LEND_MANAGEMENT_USING_ENABLED_SETTING,
  RETURNED_RESERVE_STATUS_SETTING,
  TOOLI_BIBLIOGRAPHY_REGISTER_PARAMETER2,
  RESERVE_CONTACT_METHOD_DEFAULT_VALUE_SETTING,
  MOBILE_LIBRARY_PROCESSING_PLACE,
  RESERVE_FORWARDING_ENABLED_SETTING,
  LEND_OUT_COLLECTION_DISPLAY_SETTING,
  FAMILY_MANAGEMENT_BASIC_NUMBER_SETTING,
  MAIL_HISTORY_SETTING,
  INSPECTION_MAX_NUMBER,
  PROCESSING_METHOD_SETTING,
  LEND_RETURN_MESSAGE_OUTPUT_SETTING,
  RESERVE_SPECIFY_BRANCH_CODE_DEFAULT_SETTING,
  REMINDER_METHOD_SETTING,
  LEND_METHOD_SETTING,
  ORDER_LIST_EDIT_DISPLAY_SETTING,
  RETURN_HISTORY_DISPLAY_ENABLED_SETTING,
  USER_NEW_REGISTRATION_DEFAULT_VALUE_SETTING,
  LEND_OUT_TAB_DISPLAY_ITEM_SETTING,
  REFERENCE_SEARCH_DISPLAY_SETTING,
  CODE_MASTER,
  TRADER,
  DONOR,
  JAPANESE_CALENDAR_SORT,
  RESERVE_TYPE_SELECT_DISPLAY_ENABLED,
  USER_SEARCH_PAGE_INITIAL_FOCUS
}
